import { render, staticRenderFns } from "./expertExtractionList.vue?vue&type=template&id=499d5b37&scoped=true"
import script from "./expertExtractionList.vue?vue&type=script&lang=js"
export * from "./expertExtractionList.vue?vue&type=script&lang=js"
import style0 from "./expertExtractionList.vue?vue&type=style&index=0&id=499d5b37&prod&lang=less&scoped=true"
import style1 from "./expertExtractionList.vue?vue&type=style&index=1&id=499d5b37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499d5b37",
  null
  
)

export default component.exports